module.exports = __webpack_public_path__ + "img/campaign.be70252.png";